import NotificationsError from './NotificationsError';
export default NotificationsError;
